import axios from 'axios';
import Vue from 'vue';

const state = {
    active: null
};

const mutations = {
    activate(state, integration){
        state.active = integration;
    }
};

const actions = {
    load({commit, dispatch}){
        return axios.get('/integration')
        .then(response => commit('activate', response.$data))
        .catch(error => console.log(error));
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
